const state = {
  loan_officer_assignment_id: null,
  toggle_edit_modal: false,
  toggle_assign_loan_officer_modal: false,
  borrow_id: null
}

const getters = {}

const mutations = {
  setLoanOfficerAssignment (state, loan_officer_assignment_id) {
    state.loan_officer_assignment_id = loan_officer_assignment_id
  },
  toggleEditModal (state) {
    state.toggle_edit_modal = !state.toggle_edit_modal
  },
  setBorrowId (state, borrow_id) {
    state.borrow_id = borrow_id
  },
  toggleAssignLoanOfficerModal (state) {
    state.toggle_assign_loan_officer_modal = !state.toggle_assign_loan_officer_modal
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
